// extracted by mini-css-extract-plugin
module.exports = {"title":"Settings_title__3CPQF","option":"Settings_option__1hoaE"};